import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { PlacanjeRacuna } from './placanje-racuna';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-placanje-racuna-update',
  templateUrl: './placanje-racuna-update.component.html'
})
export class PlacanjeRacunaUpdateComponent 
extends BaseUpdateComponent<PlacanjeRacuna> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Datum", Validators.required, 'required', 'PLACANJERACUNA.DATUM.VALIDATION.REQUIRED');
    // this.addValidatorToFc("BrTrans", Validators.required, 'required', 'PLACANJERACUNA.BRTRANS.VALIDATION.REQUIRED');
    // this.addValidatorToFc("UkupnoDnevniPromet", Validators.required, 'required', 'PLACANJERACUNA.UKUPNODNEVNIPROMET.VALIDATION.REQUIRED');
    // this.addValidatorToFc("UkupnoProvizija", Validators.required, 'required', 'PLACANJERACUNA.UKUPNOPROVIZIJA.VALIDATION.REQUIRED');
  
    this.IDProcessed
    .subscribe((value) => {
        if (value && this.Item.ID == -1) {
            let dateNow = new Date();
            let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
            this.baseFormGroup.patchValue({ Datum: date });
            this.baseFormGroup.get('Datum').updateValueAndValidity();
        }
    })
  
  }

}
